// store/sitesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSites } from '../pages/api/api';

// Define the initial state
const initialState = {
  sites: [],
  status: 'idle', // status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

// Define the thunk for fetching sites
export const fetchSites = createAsyncThunk(
  'sites/fetchSites',
  async (_, thunkAPI) => {
    try {
      const response = await getSites({isClient:true})
    //   console.debug("RES{", response.json())
    //   if (!response.ok) {
    //     throw new Error('Error fetching sites');
    //   }
      // console.debug("RES{---", response)
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const sitesSlice = createSlice({
  name: 'sites',
  initialState,
  reducers: {
    setSitesState: (state, action) => {
      state.sites = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSites.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSites.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.sites = action.payload;
      })
      .addCase(fetchSites.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { setSitesState } = sitesSlice.actions;
export default sitesSlice.reducer;
